
import { GoogleGenAI } from "@google/genai";

// Safe access to process.env that won't crash in browser/static hosting
const getApiKey = () => {
  try {
    if (typeof process !== 'undefined' && process.env) {
      return process.env.API_KEY || '';
    }
    // Fallback if injected via window during export
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (window as any).env?.API_KEY || '';
  } catch (e) {
    return '';
  }
};

// ZMIANA: Nie inicjalizujemy klienta globalnie, bo to powoduje błąd krytyczny jeśli klucz jest pusty.
// Klient będzie tworzony dopiero w momencie wywołania funkcji generowania.

export const generateAIContent = async (prompt: string, currentContent: string, contextType: 'title' | 'content' | 'seo'): Promise<string> => {
  const apiKey = getApiKey();
  
  if (!apiKey) {
    console.warn("API Key is missing. AI generation skipped.");
    return "Konfiguracja klucza API jest wymagana do generowania treści.";
  }

  try {
    // Inicjalizacja "Leniwa" - dopiero gdy jest potrzebna
    const ai = new GoogleGenAI({ apiKey });
  
    let systemInstruction = "You are an expert copywriter for 'Envicon Polska', a professional industrial water treatment company. You speak Polish fluently. Tone: Professional, Engineering, Trustworthy, Modern.";
    
    if (contextType === 'seo') {
      systemInstruction += " Focus on SEO keywords: odwrócona osmoza, uzdatnianie wody, przemysł, ekologia. Keep it concise (under 160 chars for descriptions).";
    }

    const fullPrompt = `
    Context: We are updating a website section.
    Current text: "${currentContent}"
    User Request: "${prompt}"
    
    Task: Rewrite or generate the content based on the user request. Return ONLY the new text, no markdown formatting if not necessary.
    `;

    const response = await ai.models.generateContent({
      model: 'gemini-2.5-flash',
      contents: fullPrompt,
      config: {
        systemInstruction: systemInstruction,
      }
    });

    return response.text?.trim() || currentContent;
  } catch (error) {
    console.error("Gemini API Error:", error);
    return "Błąd podczas generowania treści. Sprawdź konsolę lub klucz API.";
  }
};
